var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20127_364",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20127_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6652 18.9499L6.19881 12.4955C6.12606 12.4228 6.07474 12.346 6.04485 12.2653C6.01495 12.1846 6 12.0974 6 12.0037C6 11.9101 6.01495 11.8229 6.04485 11.7422C6.07474 11.6614 6.12606 11.5847 6.19881 11.512L12.6727 5.0381C12.8191 4.89161 12.9985 4.81836 13.2108 4.81836C13.423 4.81836 13.6089 4.89808 13.7683 5.05753C13.9228 5.21199 14 5.39385 14 5.6031C14 5.81237 13.9228 5.99424 13.7683 6.1487L7.91328 12.0037L13.7758 17.8662C13.9223 18.0127 13.9955 18.1901 13.9955 18.3984C13.9955 18.6066 13.9158 18.7905 13.7563 18.9499C13.6019 19.1044 13.42 19.1816 13.2108 19.1816C13.0015 19.1816 12.8196 19.1044 12.6652 18.9499Z",
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic-arrow-left.e6a2e4fb686ab37ec516a571cd0caedd.svg";
export { ForwardRef as ReactComponent };